import React, { useEffect, useRef, useState } from "react";
import { canIEdit } from "helpers/efficeHelpers";
import Editor from "components/Home/MainContent/Text/TextBody/InfoPage/InfoText/Editor/Editor";
import EdittingText from "components/Home/MainContent/Text/TextBody/InfoPage/InfoText/EdittingText/EdittingText";

const InfoText = ({ currentActiveEffice, myId }) => {
  const ref = useRef();
  const [editting, setEditting] = useState(false);
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (ref.current) {
      // ref.current.scrollTop = ref.current.scrollHeight;
      //ref.current.style.height = "35px";
      ref.current.style.height = ref.current.scrollHeight + 2 + "px";
    }
  }, [content, editting]);

  return (
    <div className={`${editting ? "widen" : ""}`}>
      {editting ? (
        <EdittingText
          elem={ref}
          content={content}
          setContent={setContent}
          loading={loading}
        />
      ) : (
        <span className="">{currentActiveEffice.content}</span>
      )}
      {canIEdit(currentActiveEffice, currentActiveEffice.role_id, myId) && (
        <Editor
          effId={currentActiveEffice.id}
          originalContent={currentActiveEffice.content}
          loading={loading}
          setLoading={setLoading}
          content={content}
          setContent={setContent}
          editting={editting}
          setEditting={setEditting}
        />
      )}
    </div>
  );
};

export default InfoText;
